import { useCallback, useEffect, useState } from 'react';
import { useQuery } from 'urql';

import { useTokenLimitCheck } from 'containers/AIQuery/containers/AIQueryChatContainer/hooks/useTokenLimitCheck';

import { FetchChatFollowups } from '../data/FetchChatFollowups.query';

export const useChatFollowups = (chatId: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState<string[]>([]);
  const { isAtLimit } = useTokenLimitCheck();

  const [{ data, fetching }, executeQuery] = useQuery({
    query: FetchChatFollowups,
    variables: { chatId },
    pause: true,
    requestPolicy: 'network-only',
  });

  useEffect(() => {
    if (!fetching && isLoading) {
      setIsLoading(false);
    }
  }, [fetching, isLoading]);

  useEffect(() => {
    if (!data?.chatFollowups.suggestions) {
      return;
    }

    setSuggestions(data?.chatFollowups?.suggestions.filter(Boolean) as string[]);
  }, [data]);

  const generateFollowups = useCallback(() => {
    if (isAtLimit) {
      return;
    }

    setIsLoading(true);

    // This is a little gross. But we need to wait for the chat to be persisted on the backend before it can generate follow ups.
    // Future state it would be nice to just have a websocket connection or subscription that we can just listen to
    setTimeout(() => {
      executeQuery();
    }, 1000);
  }, [executeQuery, isAtLimit]);

  const clearSuggestions = useCallback(() => {
    setSuggestions([]);
  }, []);

  return { suggestions, fetching: isLoading || fetching, generateFollowups, clearSuggestions };
};
